import React from 'react';

import MainWrapper from 'app/layout/MainWrapper';
import MediaEventStore from 'features/video/stores/media-event-store';
import { MiniTvRunProvider } from 'features/video/stores/mini-tv-run-store';
import { useRealtimeConnection } from 'features/realtime/useRealtimeConnection';
import { useTabRejoin } from 'features/realtime/useTabRejoin';
import { useSchedulesQuery } from 'features/events/queries';
import { useUserSessionContext } from 'features/session/userSessionStore';
import { getActiveVirtualSessionId } from 'shared/api/http-client';

import 'assets/sportsbook/styles/_spinner-overlay.scss';

function RealtimeBridge() {
  const { data: schedules = [] } = useSchedulesQuery();
  const [{ user, session_id: contextSessionId }] = useUserSessionContext();
  const sessionId = String(contextSessionId || user?.session_id || getActiveVirtualSessionId() || '') || null;

  const scheduleIds = React.useMemo(
    () =>
      (Array.isArray(schedules) ? schedules : [])
        .map((s: any) => String(s.schedule_id))
        .filter((id: string) => id && id !== 'undefined'),
    [schedules]
  );

  useRealtimeConnection(scheduleIds, sessionId);
  useTabRejoin(scheduleIds);
  return null;
}

function MainPage() {
  return (
    <MediaEventStore>
      <MiniTvRunProvider>
        <RealtimeBridge />
        <MainWrapper />
      </MiniTvRunProvider>
    </MediaEventStore>
  );
}

export default MainPage;
